// extracted by mini-css-extract-plugin
export var actions = "_ml-d";
export var benefitCard = "_ml-a";
export var benefitIcon = "_ml-b";
export var benefitLabel = "_ml-c";
export var benefits = "_ml-9";
export var bodyText = "_ml-8";
export var closeButton = "_ml-2";
export var content = "_ml-3";
export var eyebrow = "_ml-4";
export var heading = "_ml-5";
export var image = "_ml-f";
export var imagePanel = "_ml-e";
export var modal = "_ml-0";
export var shell = "_ml-1";
export var title = "_ml-6";
export var titleOffer = "_ml-7";